<template>
    <ul class="dev-nav">
        <li> dev

        <ul class="dropdown">
            <li>
                <a :href="$route('app.search')">Search</a>
            </li>
            <li>
                <a :href="$route('app.faqs')">Faqs</a>
            </li>

            <li>
                <a :href="$route('app.contact')">Contact</a>
            </li>
            <li>
                <a :href="$route('app.complaint')">Complaint</a>
            </li>

            <li>
                <a :href="$route('app.privacy')">Privacy</a>
            </li>
            <li>
                <a :href="$route('app.cookie')">Cookie</a>
            </li>

            <li>
                <a :href="$route('app.documents')">Documents</a>
            </li>
            <li>
                <a :href="$route('app.governance')">Governance</a>
            </li>
            <li>
                <a :href="$route('app.areas')">Areas</a>
            </li>
            <li>
                <a :href="$route('app.story')">Story</a>
            </li>
        </ul>

        </li>
    </ul>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
